import { NavLink } from 'react-router-dom';
import { Users, BarChart3, Lightbulb, Shield } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuthStore } from '@/stores/authStore';

const TABS = [
  { path: '/members', label: 'Members Directory', icon: Users },
  { path: '/charts', label: 'Visualizations', icon: BarChart3 },
  { path: '/insights', label: 'Key Insights', icon: Lightbulb },
];

export function TabNav() {
  const isAdmin = useAuthStore((s) => s.isAdmin());

  return (
    <nav className="border-b border-border bg-card px-6 hidden md:block">
      <div className="flex gap-1">
        {TABS.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-1.5 px-4 py-3 text-sm font-medium transition-colors border-b-2 -mb-px',
                isActive
                  ? 'border-primary text-primary'
                  : 'border-transparent text-muted-foreground hover:text-foreground'
              )
            }
          >
            <tab.icon className="h-4 w-4" />
            {tab.label}
          </NavLink>
        ))}
        {isAdmin && (
          <NavLink
            to="/admin"
            className={({ isActive }) =>
              cn(
                'flex items-center gap-1.5 px-4 py-3 text-sm font-medium transition-colors border-b-2 -mb-px',
                isActive
                  ? 'border-primary text-primary'
                  : 'border-transparent text-muted-foreground hover:text-foreground'
              )
            }
          >
            <Shield className="h-4 w-4" />
            Control Panel
          </NavLink>
        )}
      </div>
    </nav>
  );
}
